/**
 * PHOTOS §4, encoding: the one part that needs a browser. The frame goes onto a `PHOTO_W` x `PHOTO_H` canvas and
 * comes off as a JPEG through `canvas.toBlob`; which quality, and when to give up, is `encodeWithin`'s decision.
 * No canvas (node, a worker): null, and simply no picture.
 */

import { encodeWithin } from './encode';
import { MAX_PHOTO_BYTES, PHOTO_H, PHOTO_W } from './types';

export async function encodeOnCanvas(rgba: Uint8ClampedArray): Promise<Blob | null> {
  try {
    if (typeof document === 'undefined') return null;
    const canvas = document.createElement('canvas');
    canvas.width = PHOTO_W;
    canvas.height = PHOTO_H;
    const ctx = canvas.getContext('2d');
    if (ctx === null) return null;
    const image = ctx.createImageData(PHOTO_W, PHOTO_H);
    image.data.set(rgba);
    ctx.putImageData(image, 0, 0);
    // A browser that cannot write JPEG hands back a PNG instead: the server would refuse that, so it counts as none.
    const toJpeg = (quality: number): Promise<Blob | null> => new Promise((resolve) => {
      canvas.toBlob((blob) => resolve(blob !== null && blob.type === 'image/jpeg' ? blob : null), 'image/jpeg', quality);
    });
    return await encodeWithin(toJpeg, MAX_PHOTO_BYTES);
  } catch {
    return null;
  }
}
